import { render, staticRenderFns } from "./HsabTransactionChildRowItem.vue?vue&type=template&id=2a2fbe63&scoped=true"
import script from "./HsabTransactionChildRowItem.vue?vue&type=script&lang=ts"
export * from "./HsabTransactionChildRowItem.vue?vue&type=script&lang=ts"
import style0 from "./HsabTransactionChildRowItem.vue?vue&type=style&index=0&id=2a2fbe63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2fbe63",
  null
  
)

export default component.exports